// @flow

import type {HospitalState} from '../types'

export const initialState: HospitalState = {
  cities: [],
  districts: [],
  selectedCity: '',
}
